import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tag } from '@pwc/appkit-react/lib/Tag';

class NavigationButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    element: PropTypes.shape({
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
    disabled: PropTypes.bool,
  };

  onChange = () => {
    if (!this.props.disabled) {
      this.props.onChange(this.props.element.type);
    }
  };

  render() {
    const { className, element, disabled } = this.props;

    return (
      <Tag
        className={className}
        onClick={this.onChange}
        disabled={disabled}
        // type="button"
      >
        {element.label}
      </Tag>
    );
  }
}

export default NavigationButton;
